import { Grid, makeStyles } from '@material-ui/core';
import {
  BarChart as BarChartIcon,
  DonutLarge as DonutLargeIcon,
} from '@material-ui/icons';
import { CardOption } from 'components/DynamicDashboard/interfaces';
import React from 'react';
import BarGraph from '../Graphs/Bar';
import DoughnutGraph from '../Graphs/Doughnut';
import GraphOption from './GraphOption';
import styles from './styles';

const useStyles = makeStyles(styles);

interface CardModalProps {
  values: Array<CardOption & { count: number }>;
}

const CardModal = ({ values }: CardModalProps) => {
  const classes = useStyles();

  const [graphType, setGraphType] = React.useState<'doughnut' | 'bar' | string>(
    'doughnut'
  );

  const graphOptions = [
    { name: 'doughnut', labelKey: 'DONUT_GRAPH_KEY', icon: DonutLargeIcon },
    { name: 'bar', labelKey: 'BAR_GRAPH_KEY', icon: BarChartIcon },
  ];

  const renderGraphComponent = () => {
    const graphComponents: Record<'doughnut' | 'bar', React.ReactNode> = {
      doughnut: <DoughnutGraph isModal values={values} />,
      bar: <BarGraph values={values} />,
    };

    return graphComponents[graphType] || null;
  };

  return (
    <Grid container>
      <Grid container justify="center" className={classes.statusModalGrid}>
        {graphOptions.map(option => (
          <GraphOption
            key={option.name}
            name={option.name}
            labelKey={option.labelKey}
            icon={option.icon}
            selectedGraph={graphType}
            onChange={setGraphType}
          />
        ))}
      </Grid>
      <Grid container>{renderGraphComponent()}</Grid>
    </Grid>
  );
};

export default CardModal;
